import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../context/GlobalState';
import { BandCardForm } from './BandCardForm';
import { MusicianCardForm } from './MusicianCardForm';
import { MyMusicianCard } from './MyMusicianCard';
import { MyBandCard } from './MyBandCard';

export const MyCards = () => {
  const { userId, bands, musicians, loadBands, loadMusicians } =
    useContext(GlobalContext);

  useEffect(() => {
    loadBands();
    loadMusicians();
  }, [loadBands, loadMusicians]);

  const myBandCards = bands.filter(card => userId === card.userId);
  const myMusicianCards = musicians.filter(card => userId === card.userId);

  const [createBandCard, setCreateBandCard] = useState(false);
  const [createMusicianCard, setCreateMusicianCard] = useState(false);

  return (
    <>
      <section className='usage-guide'>
        <h3>Tips for Better Matches</h3>
        <ul>
          <li>Add at least one clear profile photo for better trust.</li>
          <li>Describe style, level, and weekly availability in your card.</li>
          <li>When applying, mention what role you want and your city.</li>
          <li>Your email is shared with the card owner after you apply.</li>
        </ul>
      </section>

      <div className='container-add-buttons'>
        <div className='container-add-button'>
          <button
            onClick={() => {
              setCreateBandCard(!createBandCard);
            }}
          >
            Add New Band Card
          </button>

          {createBandCard && (
            <BandCardForm setCreateBandCard={setCreateBandCard} />
          )}
        </div>
        <div className='container-add-button'>
          <button
            onClick={() => {
              setCreateMusicianCard(!createMusicianCard);
            }}
          >
            Add New Musician Card
          </button>
          {createMusicianCard && (
            <MusicianCardForm setCreateMusicianCard={setCreateMusicianCard} />
          )}
        </div>
      </div>

      <ul className='cards cards-mypage'>
        {myBandCards.length > 0 &&
          myBandCards.map(band => <MyBandCard key={band._id} band={band} />)}

        {myMusicianCards.length > 0 &&
          myMusicianCards.map(musician => (
            <MyMusicianCard key={musician._id} musician={musician} />
          ))}
      </ul>
    </>
  );
};
